import styles from "../../EnergyLabel.module.scss";
import { ALPHA__Drawer as DSDrawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import OpenInNew24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/OpenInNew24PxOutlined";

export type DrawerProps = {
  isOpen: boolean;
  isLegacy: boolean;
  handleClose: () => void;
  rating: string;
  label?: string;
  informationSheet?: string;
};

export const Drawer = ({
  isOpen,
  handleClose,
  rating,
  label,
  informationSheet,
  isLegacy,
}: DrawerProps) => {
  const noLabelText = isLegacy
    ? `This item is rated ${rating} for energy efficiency on a scale from A+++ (most efficient) to D (least efficient).`
    : `This item is rated ${rating} for energy efficiency on a scale from A (most efficient) to G (least efficient).`;

  return (
    <DSDrawer
      isOpen={isOpen}
      onClose={handleClose}
      header={`Energy Rating: ${rating}`}
      isHeaderFixed={true}
      isNarrow={false}
      rootId="page-root"
      isFooterFixed
      isDrawerLeft={false}
      footerChildren={
        <div className={styles.footer}>
          {!!label && (
            <UnderlinedButton
              className={styles.externalButton}
              tag="a"
              target="_blank"
              href={label}
            >
              Energy Label
              <OpenInNew24PxOutlinedIcon />
            </UnderlinedButton>
          )}
          {!!informationSheet && (
            <UnderlinedButton
              className={styles.externalButton}
              tag="a"
              target="_blank"
              href={informationSheet}
            >
              Product Information Sheet
              <OpenInNew24PxOutlinedIcon />
            </UnderlinedButton>
          )}
        </div>
      }
    >
      {label ? (
        <img src={label} alt={noLabelText} className={styles.energyLabel} />
      ) : (
        <div data-testid="energy-label-efficiency-explanation">
          {noLabelText}
        </div>
      )}
    </DSDrawer>
  );
};
